<template>
  <div class="sub-page-v2">
    <div class="page-hero-small">
      <h1>{{ $t('common.news') }}</h1>
    </div>
    <div class="container-v2 page-body-v2">
      <SubNavV2 :items="navItems" />
      <router-view />
    </div>
  </div>
</template>

<script>
import SubNavV2 from '@/components/SubNavV2.vue'

export default {
  name: 'NewsIndexV2',
  components: { SubNavV2 },
  data() {
    return {
      navItems: [
        { nameKey: 'common.companyNews', path: '/news/list' },
        { nameKey: 'common.journal', path: '/news/internal' },
        { nameKey: 'common.safety', path: '/news/safety' }
      ]
    }
  }
}
</script>
